import { ShieldAlert } from "lucide-react";

export function Disclaimer({ compact = false, className = "" }) {
  return (
    <div
      data-testid="astrology-disclaimer"
      className={`flex items-start gap-3 rounded-xl border border-amber-500/15 bg-[#0E132A]/60 px-4 py-3 ${className}`}
    >
      <ShieldAlert size={compact ? 16 : 18} className="text-amber-400/80 mt-0.5 shrink-0" />
      <p className={`text-slate-400 leading-relaxed ${compact ? "text-xs" : "text-sm"}`}>
        MyssticChat provides astrology-based guidance for personal reflection and entertainment.
        Astrology predictions are not guaranteed outcomes and should not be considered professional
        medical, legal, financial or investment advice.
      </p>
    </div>
  );
}
